import { render, staticRenderFns } from "./ConsultarVoucherZeResultado.vue?vue&type=template&id=585ba1d0&scoped=true"
import script from "./ConsultarVoucherZeResultado.vue?vue&type=script&lang=js"
export * from "./ConsultarVoucherZeResultado.vue?vue&type=script&lang=js"
import style0 from "./ConsultarVoucherZeResultado.vue?vue&type=style&index=0&id=585ba1d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585ba1d0",
  null
  
)

export default component.exports